import createIcon from '../../createIcon';

/**
 * @component @name Sixmp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuNSA5SDEzVjEwLjVIMTEuNVY5Wk0xOSAzSDVDMy45IDMgMyAzLjkgMyA1VjE5QzMgMjAuMSAzLjkgMjEgNSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWNUMyMSAzLjkgMjAuMSAzIDE5IDNaTTEyIDE4LjVIMTAuNVYxNEg5LjVWMTdIOFYxNEg3VjE4LjVINS41VjEzLjVDNS41IDEyLjk1IDUuOTUgMTIuNSA2LjUgMTIuNUgxMUMxMS41NSAxMi41IDEyIDEyLjk1IDEyIDEzLjVWMTguNVpNMTEgMTEuNUMxMC40NSAxMS41IDEwIDExLjA1IDEwIDEwLjVWNi41QzEwIDUuOTUgMTAuNDUgNS41IDExIDUuNUgxNC41VjdIMTEuNVY4SDEzLjVDMTQuMDUgOCAxNC41IDguNDUgMTQuNSA5VjEwLjVDMTQuNSAxMS4wNSAxNC4wNSAxMS41IDEzLjUgMTEuNUgxMVpNMTUuNSAxOC41SDE0VjEyLjVIMTcuNUMxOC4wNSAxMi41IDE4LjUgMTIuOTUgMTguNSAxMy41VjE2QzE4LjUgMTYuNTUgMTguMDUgMTcgMTcuNSAxN0gxNS41VjE4LjVaTTE1LjUgMTRIMTdWMTUuNUgxNS41VjE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sixmp = createIcon('Sixmp', [
  [
    'path',
    {
      d: 'M11.5 9H13V10.5H11.5V9ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 18.5H10.5V14H9.5V17H8V14H7V18.5H5.5V13.5C5.5 12.95 5.95 12.5 6.5 12.5H11C11.55 12.5 12 12.95 12 13.5V18.5ZM11 11.5C10.45 11.5 10 11.05 10 10.5V6.5C10 5.95 10.45 5.5 11 5.5H14.5V7H11.5V8H13.5C14.05 8 14.5 8.45 14.5 9V10.5C14.5 11.05 14.05 11.5 13.5 11.5H11ZM15.5 18.5H14V12.5H17.5C18.05 12.5 18.5 12.95 18.5 13.5V16C18.5 16.55 18.05 17 17.5 17H15.5V18.5ZM15.5 14H17V15.5H15.5V14Z',
      key: 'pvottg',
    },
  ],
]);

export default Sixmp;
